'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { ClientErrorBoundary } from '@/components/ClientErrorBoundary';

// Lazy-load below-fold analytics & chat components to reduce TBT
const ZapChat = dynamic(() => import('@/components/ZapChat'), { ssr: false });
const MarketingTracker = dynamic(() => import('@/components/marketing/MarketingTracker'), { ssr: false });
const PurchaseTracker = dynamic(() => import('@/components/analytics/PurchaseTracker'), { ssr: false });
const KlaviyoPixel = dynamic(() => import('@/components/marketing/klaviyo-pixel'), { ssr: false });
const ClarityScript = dynamic(() => import('@/components/analytics/ClarityScript'), { ssr: false });

export function ClientDynamicWrapper() {
  return (
    <ClientErrorBoundary>
      <Suspense fallback={null}>
        <ZapChat />
        <MarketingTracker />
        <PurchaseTracker />
      </Suspense>
    </ClientErrorBoundary>
  );
}

export function ClientKlaviyoPixel() {
  return (
    <ClientErrorBoundary>
      <KlaviyoPixel />
    </ClientErrorBoundary>
  );
}

export function ClientClarityScript() {
  return (
    <ClientErrorBoundary>
      <ClarityScript />
    </ClientErrorBoundary>
  );
}
